import React from 'react'

export default function ChevronRightIcon ({ ...props }) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 59.27 89.44'>
      <path d='M10.28,89.44A10.28,10.28,0,0,1,3,71.89L30.18,44.72,3,17.55A10.28,10.28,0,0,1,17.55,3L59.27,44.72,17.55,86.43A10.23,10.23,0,0,1,10.28,89.44Z' />
    </svg>
  )
}
